// see config: https://app.clickup.com/5747967/v/dc/5fd7z-7165/5fd7z-32418
export const DEFAULT_REFERRAL_CHANNEL = '\x00\x00\x00\x00\x00\x00'; // default channel
export const DEFAULT_REFERRAL_WALLET = 1; // default wallet as Metamask
